export const ActionTypes = {
  LOADING: "GET_A_HISTORY_LOADING",
  ERROR: "GET_A_HISTORY_ERROR",
  SUCCESS: "GET_A_HISTORY_SUCCESS"
};
